import { useEffect, useRef, useState } from 'react';
import ResponsiveNavLink from '@/Components/ResponsiveNavLink.jsx';
import JobBoardIcon from '@/Pages/Tools/Partials/JobBoardIcon.jsx';
import MockInterviewIcon from '@/Pages/Tools/Partials/MockInterviewIcon.jsx';
import CoverLetterBuilderIcon from '@/Pages/Tools/Partials/CoverLetterBuilderIcon.jsx';
import ResumeBuilderIcon from '@/Pages/Tools/Partials/ResumeBuilderIcon.jsx';
import { FaList } from 'react-icons/fa';

const MoreAIJobToolsDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Function to handle clicks outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  return (
    <div className="relative lg:mr-4" ref={dropdownRef}>
      {/* Dropdown Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex font-medium items-center justify-between w-full ps-3 pe-3 py-3 md:py-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:dark:hover:text-white dark:focus:text-white dark:border-gray-700 md:dark:hover:bg-transparent"
      >
        More AI Job Tools
        <svg
          className="w-2.5 h-2.5 ml-2"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 10 6"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m1 1 4 4 4-4"
          />
        </svg>
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute z-[100] mt-2 w-64 bg-white divide-y divide-gray-100 rounded-lg shadow-lg dark:bg-gray-800 dark:divide-gray-700 border border-gray-200 dark:border-gray-700">
          <ul className="py-1 text-sm text-gray-800 dark:text-gray-200">
            <li>
              <ResponsiveNavLink
                href={route('builder')}
                active={route().current('builder.section')}
                className="flex items-center px-4 py-2 text-sm"
              >
                <ResumeBuilderIcon size={20} className="text-indigo-600 dark:text-indigo-400" />
                <span className="ml-2">AI Resume Builder</span>
              </ResponsiveNavLink>
            </li>
            <li>
              <ResponsiveNavLink
                href={route('cover-letter')}
                active={route().current('cover-letter')}
                className="flex items-center px-4 py-2 text-sm"
              >
                <CoverLetterBuilderIcon size={20} className="text-green-600 dark:text-green-400" />
                <span className="ml-2">
                  AI Cover Letter Maker{' '}
                  <span className="bg-green-100 text-green-800 text-xs font-medium me-2 px-1.5 py-0.5 rounded-sm dark:bg-green-900 dark:text-green-300">
                    Free
                  </span>
                </span>
              </ResponsiveNavLink>
            </li>
            <li>
              <ResponsiveNavLink
                href={route('mock-interview')}
                active={route().current('mock-interview')}
                className="flex items-center px-4 py-2 text-sm"
              >
                <MockInterviewIcon size={20} className="text-purple-600 dark:text-purple-400" />
                <span className="ml-2">AI Mock Interview</span>
              </ResponsiveNavLink>
            </li>
            <li>
              <ResponsiveNavLink
                href={route('jobs')}
                active={route().current('jobs')}
                className="flex items-center px-4 py-2 text-sm"
              >
                <JobBoardIcon size={20} className="text-amber-600 dark:text-amber-400" />
                <span className="ml-2">AI Job Board</span>
              </ResponsiveNavLink>
            </li>
          </ul>
          {/* "Show All AI Tools" Option */}
          <div className="py-1">
            <ResponsiveNavLink
              href={route('tools')}
              active={route().current('tools')}
              className="flex items-center px-4 py-2 text-sm font-medium text-blue-600 dark:text-blue-300 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              <FaList className="text-blue-600 dark:text-blue-300" size={16} />
              <span className="ml-2">View All Tools</span>
            </ResponsiveNavLink>
          </div>
        </div>
      )}
    </div>
  );
};

export default MoreAIJobToolsDropdown;
